// Copyright (c) 2025 Audere, All Rights Reserved

import './index.css';
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "./i18n";

import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from "react-router";
import { ThemeProvider } from '@emotion/react';

import { theme } from './theme';
import { Provider } from 'react-redux';
import { persistor, store } from './app/features/store';
import { PersistGate } from 'redux-persist/integration/react';
import { router } from './app/routes';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <RouterProvider router={router} />
          </PersistGate>
        </Provider>
    </ThemeProvider>
  </React.StrictMode>,
)
